export function Logo1am({ className = '', animated = false }) {
  const classes = ['logo-1am', animated ? 'logo-1am--animated' : '', className].filter(Boolean).join(' ')

  return (
    <svg className={classes} width="105" height="32" viewBox="0 0 105 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M47.6389 3.46175V28.0674H44.5917V6.51876H40.2921V3.46175H47.6389Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.921 3.46175L74.3795 28.0674H71.3711L69.1511 22.2814H57.4757L55.256 28.0674H52.2474L61.7059 3.46175H64.921ZM58.6311 19.2244H67.9772L63.3233 7.13112L58.6311 19.2244Z"
        fill="currentColor"
      />
      <path d="M82.1032 3.46175L91.8102 22.7244L101.535 3.46175H105V28.0674H101.97V9.90855L101.464 9.78665L92.188 28.0674H91.4504L82.1747 9.78665L81.668 9.90855V28.0674H78.6211V3.46175H82.1032Z" fill="currentColor" />
      <g className="logo-1am__icon">
        <path d="M22.3487 1.34876C29.8067 4.61768 33.6916 13.1099 31.0886 21.0171C28.3273 29.4053 19.31 33.9593 10.9486 31.1885C2.58715 28.4177-1.95282 19.3711 0.808541 10.9829C3.4091 3.08318 11.5581-1.41591 19.4825 0.401224L18.5554 3.21739C12.1869 1.90495 5.688 5.56745 3.60067 11.9081C1.35211 18.7386 5.06205 26.1311 11.8707 28.3874C18.6793 30.6436 26.0482 26.9213 28.2967 20.0909C30.3865 13.7427 27.3303 6.90924 21.4218 4.16441L22.3487 1.34876ZM20.0268 3.61162C20.5076 3.77095 20.9729 3.95588 21.4218 4.16441L16.9003 17.8994L14.0347 16.9498L18.5554 3.21739C19.0473 3.31878 19.5385 3.44981 20.0268 3.61162Z" fill="currentColor" />
      </g>
    </svg>
  )
}
